/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const CHANGE_GROUP = 'CHANGE_GROUP';
export const CHANGE_PROPERTY = 'CHANGE_PROPERTY';
export const CHANGE_DOMAINS = 'CHANGE_DOMAINS';
export const CHANGE_TIMEZONE = 'CHANGE_TIMEZONE';
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY';
export const CHANGE_USER = 'CHANGE_USER';

export const CHECK_PIN = 'CHECK_PIN';

export const CHANGE_CLODBEDS = 'CHANGE_CLODBEDS';
export const CHANGE_CLODBEDS_CODE = 'CHANGE_CLODBEDS_CODE';
export const CHECK_VOUCHER_ENGINE = 'CHECK_VOUCHER_ENGINE';
/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
  'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/* CHAT LIST APP*/
export const CHAT_LIST_GET_LIST = 'CHAT_LIST_GET_LIST';
export const CHAT_LIST_GET_LIST_SUCCESS = 'CHAT_LIST_GET_LIST_SUCCESS';
export const CHAT_LIST_GET_LIST_ERROR = 'CHAT_LIST_GET_LIST_ERROR';
export const CHAT_LIST_GET_LIST_WITH_FILTER = 'CHAT_LIST_GET_LIST_WITH_FILTER';
export const CHAT_GET = 'CHAT_GET';
export const CHAT_GET_SUCCESS = 'CHAT_GET_SUCCESS';
export const CHAT_GET_ERROR = 'CHAT_GET_ERROR';

export const AVAILABLITY_LIST_GET_LIST = 'AVAILABLITY_LIST_GET_LIST';
export const AVAILABLITY_LIST_GET_LIST_SUCCESS =
  'AVAILABLITY_LIST_GET_LIST_SUCCESS';
export const AVAILABLITY_LIST_GET_LIST_ERROR =
  'AVAILABLITY_LIST_GET_LIST_ERROR';
export const AVAILABLITY_LIST_GET_LIST_WITH_FILTER =
  'AVAILABLITY_LIST_GET_LIST_WITH_FILTER';

export const BOOKING_LIST_GET_LIST = 'BOOKING_LIST_GET_LIST';
export const BOOKING_LIST_GET_LIST_SUCCESS = 'BOOKING_LIST_GET_LIST_SUCCESS';
export const BOOKING_LIST_GET_LIST_ERROR = 'BOOKING_LIST_GET_LIST_ERROR';
export const BOOKING_LIST_GET_LIST_WITH_FILTER =
  'BOOKING_LIST_GET_LIST_WITH_FILTER';

export const TICKET_LIST_GET_LIST = 'TICKET_LIST_GET_LIST';
export const TICKET_LIST_GET_LIST_SUCCESS = 'TICKET_LIST_GET_LIST_SUCCESS';
export const TICKET_LIST_GET_LIST_ERROR = 'TICKET_LIST_GET_LIST_ERROR';
export const TICKET_LIST_GET_LIST_WITH_FILTER =
  'TICKET_LIST_GET_LIST_WITH_FILTER';
export const TICKET_GET = 'TICKET_GET';
export const TICKET_GET_SUCCESS = 'TICKET_GET_SUCCESS';
export const TICKET_GET_ERROR = 'TICKET_GET_ERROR';

export const CREATE_TICKET = 'CREATE_TICKET';
export const CREATE_TICKET_SUCCESS = 'CREATE_TICKET_SUCCESS';
export const CREATE_TICKET_ERROR = 'CREATE_TICKET_ERROR';

export const ROLE_LIST_GET_LIST = 'ROLE_LIST_GET_LIST';
export const ROLE_LIST_GET_LIST_SUCCESS = 'ROLE_LIST_GET_LIST_SUCCESS';
export const ROLE_LIST_GET_LIST_ERROR = 'ROLE_LIST_GET_LIST_ERROR';
export const ROLE_LIST_GET_LIST_WITH_FILTER = 'ROLE_LIST_GET_LIST_WITH_FILTER';

export const PROPERTY_LIST_GET_LIST = 'PROPERTY_LIST_GET_LIST';
export const PROPERTY_LIST_GET_LIST_SUCCESS = 'PROPERTY_LIST_GET_LIST_SUCCESS';
export const PROPERTY_LIST_GET_LIST_ERROR = 'PROPERTY_LIST_GET_LIST_ERROR';
export const PROPERTY_LIST_GET_LIST_WITH_FILTER =
  'PROPERTY_LIST_GET_LIST_WITH_FILTER';

export const AGENT_LIST_GET_LIST = 'AGENT_LIST_GET_LIST';
export const AGENT_LIST_GET_LIST_SUCCESS = 'AGENT_LIST_GET_LIST_SUCCESS';
export const AGENT_LIST_GET_LIST_ERROR = 'AGENT_LIST_GET_LIST_ERROR';
export const AGENT_LIST_GET_LIST_WITH_FILTER =
  'AGENT_LIST_GET_LIST_WITH_FILTER';

export const USER_LIST_GET_LIST = 'USER_LIST_GET_LIST';
export const USER_LIST_GET_LIST_SUCCESS = 'USER_LIST_GET_LIST_SUCCESS';
export const USER_LIST_GET_LIST_ERROR = 'USER_LIST_GET_LIST_ERROR';
export const USER_LIST_GET_LIST_WITH_FILTER = 'USER_LIST_GET_LIST_WITH_FILTER';
export const USER_ROLE = 'USER_ROLE';
export const CONNECT_USER = 'CONNECT_USER';
export const CONNECT_SUCCESS = 'CONNECT_SUCCESS';

export * from './menu/actions';
export * from './settings/actions';
export * from './auth/actions';
export * from './chatList/actions';
export * from './availablity/actions';
export * from './bookings/actions';
export * from './ticketList/actions';
export * from './createTicket/actions';
export * from './users/actions';
export * from './signalr/actions';
